/* Mini-coș la hover pe iconița de coș din header (doar desktop, cu mouse). Click pe iconiță → pagina coșului. */
(function () {
  if (window.xplodeMiniCart) return;
  window.xplodeMiniCart = true;
  if (!window.matchMedia('(hover: hover) and (min-width: 990px)').matches) return;

  var root = document.documentElement;
  var MIN_ITEMS = parseInt(root.getAttribute('data-free-shipping-items') || '0', 10);
  var MIN_SPEND = parseInt(root.getAttribute('data-free-shipping-spend') || '0', 10);
  var MAX_SHOWN = 3;
  var panel, wrap, hideTimer, cartPromise;

  function money(c) {
    if (typeof window.formatMoney === 'function') {
      try { return window.formatMoney(c); } catch (e) { /* fallback */ }
    }
    return (c / 100).toFixed(2).replace('.', ',') + ' lei';
  }

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  function imgUrl(src) {
    if (!src) return '';
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=120';
  }

  function render(cart) {
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    if (!cart.item_count) {
      panel.innerHTML = '<p class="mini-cart__title">Coșul tău</p><p class="mini-cart__empty">Coșul tău e gol deocamdată.</p>';
      return;
    }
    var html = '<p class="mini-cart__title">Coșul tău (' + cart.item_count + (cart.item_count === 1 ? ' produs' : ' produse') + ')</p><ul class="mini-cart__list" role="list">';
    cart.items.slice(0, MAX_SHOWN).forEach(function (item) {
      html += '<li class="mini-cart__item">' +
        (item.image ? '<img src="' + esc(imgUrl(item.image)) + '" alt="" loading="lazy">' : '') +
        '<div><div class="mini-cart__name">' + esc(item.product_title) + '</div>' +
        '<div class="mini-cart__meta">' + (item.variant_title ? esc(item.variant_title.replace(/ \/ /g, ' · ')) + ' · ' : '') +
        item.quantity + ' × ' + money(item.final_price) + '</div></div></li>';
    });
    html += '</ul>';
    if (cart.items.length > MAX_SHOWN) {
      var more = cart.items.length - MAX_SHOWN;
      html += '<p class="mini-cart__more">+ încă ' + more + (more === 1 ? ' produs' : ' produse') + ' în coș</p>';
    }
    if (MIN_ITEMS || MIN_SPEND) {
      var reached = (MIN_ITEMS && cart.item_count >= MIN_ITEMS) || (MIN_SPEND && cart.total_price >= MIN_SPEND);
      if (reached) {
        html += '<div class="mini-cart__ship mini-cart__ship--done"><strong>Ai transport gratuit!</strong> 🎉</div>';
      } else if (MIN_ITEMS) {
        var left = MIN_ITEMS - cart.item_count;
        html += '<div class="mini-cart__ship">Mai adaugă <strong>' + (left === 1 ? 'un produs' : left + ' produse') + '</strong> și ai transport gratuit.</div>';
      }
    }
    html += '<div class="mini-cart__total"><span>Subtotal</span><span>' + money(cart.total_price) + '</span></div>' +
      '<div class="mini-cart__actions"><a class="atc-btn atc-btn--ghost" href="' + cartUrl + '">Vezi coșul</a>' +
      '<a class="atc-btn atc-btn--primary" href="/checkout">Finalizează</a></div>';
    panel.innerHTML = html;
  }

  function load() {
    cartPromise = fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    return cartPromise;
  }

  function open() {
    clearTimeout(hideTimer);
    if (!panel.innerHTML) panel.innerHTML = '<p class="mini-cart__empty">Se încarcă…</p>';
    load().then(render).catch(function () {});
    panel.classList.add('is-open');
  }

  function scheduleHide() {
    clearTimeout(hideTimer);
    hideTimer = setTimeout(function () { panel.classList.remove('is-open'); }, 200);
  }

  function init() {
    var link = document.getElementById('cart-icon-bubble');
    if (!link) return;
    wrap = link.closest('.header__cart') || link.parentElement;
    if (wrap.querySelector('.mini-cart')) return;
    panel = document.createElement('div');
    panel.className = 'mini-cart';
    wrap.appendChild(panel);
    wrap.addEventListener('mouseenter', open);
    wrap.addEventListener('mouseleave', scheduleHide);
    // după o adăugare în coș, conținutul se reîncarcă la următorul hover
    document.addEventListener('xplode:added-to-cart', function () { panel.innerHTML = ''; });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
